import * as React from 'react';
import { logout } from '../../api/authClientApi';
import { PublicPageWrapper } from '../_pageWrappers/PublicPageWrapper';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { getMaybeActiveEmployeeOrLogin } from '../../api/serverApiHelpers';
import { Navigate } from 'react-router-dom';
import { applicationEndpoints } from '../../amorg-common/applicationEndpoints';

export function PortalLogoutPage(): JSX.Element
{
    return (
        <PublicPageWrapper>
            <PortalLogoutPageContent />
        </PublicPageWrapper>
    );
}

function PortalLogoutPageContent(): JSX.Element 
{
    const [loading, setLoading] = React.useState(true);
    const [siteId, setSiteId] = React.useState('');

    React.useEffect(() => {
        async function run() {
            const user = await getMaybeActiveEmployeeOrLogin();
            if(user)
            {
                setSiteId(user.siteId);
            }
            await logout();
            setLoading(false);
        }
        run();
    },[]);

    return (
        <>
                
            <LoadingPageOverlay loading={loading} />

            {!loading &&
                <>
                    {siteId 
                        ?
                        <Navigate to={applicationEndpoints.portal_login_siteId.replace(':siteId', siteId)} />
                        :
                        <Navigate to={applicationEndpoints.portal_login} />
                    }
                </>
            }
                
        </>
    );
}